import { useCallback } from 'react';

import { useDeferredInboxEntryAction } from './useDeferredInboxEntryAction';
import { PendingActionType } from '../../store/PendingActions';

interface UseInboxEntryDeferredActionsParams {
  inboxEntryId: string;
  subject?: string;
  onAction?: () => void;
}

interface UseInboxEntryDeferredActionsReturn {
  handleDeferredDelete: () => void;
  handleDeferredResolve: () => void;
  handleDeferredUnresolve: () => void;
}

export function useInboxEntryDeferredActions({
  inboxEntryId,
  subject,
  onAction,
}: UseInboxEntryDeferredActionsParams): UseInboxEntryDeferredActionsReturn {
  const { scheduleAction } = useDeferredInboxEntryAction();

  const handleDeferredDelete = useCallback(() => {
    scheduleAction({
      type: PendingActionType.DELETE,
      entryId: inboxEntryId,
      entrySubject: subject ?? '',
    });
    onAction?.();
  }, [scheduleAction, inboxEntryId, subject, onAction]);

  const handleDeferredResolve = useCallback(() => {
    scheduleAction({
      type: PendingActionType.RESOLVE,
      entryId: inboxEntryId,
      entrySubject: subject ?? '',
    });
    onAction?.();
  }, [scheduleAction, inboxEntryId, subject, onAction]);

  const handleDeferredUnresolve = useCallback(() => {
    scheduleAction({
      type: PendingActionType.UNRESOLVE,
      entryId: inboxEntryId,
      entrySubject: subject ?? '',
    });
    onAction?.();
  }, [scheduleAction, inboxEntryId, subject, onAction]);

  return {
    handleDeferredDelete,
    handleDeferredResolve,
    handleDeferredUnresolve,
  };
}
